import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=31a9d313&scoped=true&"
import script from "./HistoryTable.vue?vue&type=script&lang=js&"
export * from "./HistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTable.vue?vue&type=style&index=0&id=31a9d313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9d313",
  null
  
)

export default component.exports